function Loading() {
    return (
        <div className="loader" />
    );
}

export default Loading;
